<template>
	<div class="note-edit-wrapper mt-5">
		<div v-if="editableNote" style="width: 100%">
			<div class="d-flex justify-space-between align-center flex-wrap">
				<div class="d-flex align-center flex-nowrap">
					<Avatar
						borderRadius="square"
						:size="52"
						:avatar="editableNote.follow.user_logo"
					/>
					<div class="note-edit-wrapper__info ml-3">
						<div class="note-edit-wrapper__username text-2-lines">
							{{ editableNote.follow.visible_username }}
						</div>
					</div>
				</div>
				<div class="note-edit-wrapper__date">
					{{ dateCreated(editableNote.note_updated) }}
				</div>
			</div>
			<div class="note-edit-wrapper__text">
				{{ editableNote.follow_note }}
			</div>
			<div class="note-edit-wrapper__buttons mt-3">
				<button
					type="button"
					class="note-edit-wrapper__buttons__edit"
					@click="switchNoteFormModal"
				>
					Edit
				</button>
				<button
					class="note-edit-wrapper__buttons__delete"
					@click="switchConfirmDeleteModal"
				>
					Delete
				</button>
			</div>
		</div>
		<div v-if="isShowNoteFormModal">
			<NoteFormModal
				v-on:closeModal="switchNoteFormModal"
				:show="isShowNoteFormModal"
				:id="editableNote.follow_id"
				:note="editableNote.follow_note"
				:username="editableNote.follow.visible_username"
				:edit="true"
			/>
		</div>
		<div v-if="isShowConfirmDeleteModal">
			<ConfirmActionModal
				v-on:closeModal="switchConfirmDeleteModal"
				v-on:confirmAction="removeNote"
				:show="isShowConfirmDeleteModal"
				:isLoading="isLoading"
				title="Are you sure you want to delete this note?"
				actionName="Delete"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Avatar from '@/components/Avatar'
import NoteFormModal from '@/components/Modals/NoteFormModal.vue'
import ConfirmActionModal from '../../components/Modals/ConfirmActionModal.vue'

export default {
	components: {
		Avatar,
		NoteFormModal,
		ConfirmActionModal,
	},
	data() {
		return {
			isShowNoteFormModal: false,
			isShowConfirmDeleteModal: false,
		}
	},
	computed: {
		...mapGetters('profile', ['editableNote', 'isLoading']),
	},
	watch: {
		editableNote(newValue, oldValue) {
			!newValue && oldValue && this.toNotesPage()
		},
	},
	methods: {
		...mapActions('profile', ['updateEditableNote', 'deleteNote', 'getNoteById']),

		dateCreated(originalDate) {
			const date = new Date(originalDate * 1000)
			const options = { year: 'numeric', month: 'long', day: 'numeric' }
			return date.toLocaleDateString('en-US', options)
		},

		switchNoteFormModal() {
			this.isShowNoteFormModal = !this.isShowNoteFormModal
		},

		switchConfirmDeleteModal() {
			this.isShowConfirmDeleteModal = !this.isShowConfirmDeleteModal
		},

		toNotesPage() {
			this.$router.push({
				name: 'profile-notes',
			})
		},

		async removeNote() {
			await this.deleteNote(this.editableNote.follow_id)
		},
	},
	mounted() {
		!this.editableNote && this.toNotesPage()
	},
	beforeDestroy() {
		this.editableNote && this.updateEditableNote(null)
	},
}
</script>

<style lang="scss">
.note-edit-wrapper {
	display: flex;
	flex-direction: column;
	max-width: 555px;
	width: 100%;
	background: #ffffff;
	border-radius: 8px;
	padding: 12px;
	border: 1px solid #e2e2e2;
	&__buttons {
		display: flex;
		gap: 16px;
		justify-content: center;
		&__edit {
			width: 150px;
			height: 46px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 18px;
			line-height: 100%;
			letter-spacing: 0;
			text-align: center;
			color: var(--accent-color);
			background-color: #ffffff;
			border-radius: 8px;
			border: 1.5px solid var(--accent-color);
		}
		&__delete {
			width: 150px;
			height: 46px;
			background-color: var(--accent-color);
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 18px;
			line-height: 100%;
			letter-spacing: 0;
			text-align: center;
			border-radius: 8px;
			color: #ffffff;
		}
	}
	&__info {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}
	&__username {
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
		color: var(--username-category-title);
	}
	&__date {
		height: 46px;
		display: flex;
		align-items: flex-end;
		color: #9b9b9b;
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
	}
	&__text {
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
		color: #4a4a4a;
		margin: 16px 0 0 !important;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		word-break: break-word;
	}
}
</style>
